// src/context/AuthContext.jsx
import React, { createContext, useState, useEffect } from 'react';
import { loginUser, logoutUser, getCurrentUser } from '../api/auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Check if user is logged in on initial load
  useEffect(() => {
    const checkAuthStatus = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem('token');
        if (token) {
          // Try to get user data with the stored token
          const userData = await getCurrentUser();
          setUser(userData);
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        // If token is invalid, clear it
        logoutUser();
        setIsAuthenticated(false);
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  // Login function
  const login = async (email, password) => {
    setError(null);
    try {
      const authData = await loginUser(email, password);
      setUser(authData.user);
      setIsAuthenticated(true);
      return authData;
    } catch (error) {
      setError(error.message || 'Login failed');
      throw error;
    }
  };

  // Logout function
  const logout = () => {
    logoutUser();
    setIsAuthenticated(false);
    setUser(null);
  };

  // Value object to be provided to consumers
  const value = {
    isAuthenticated,
    user,
    isLoading,
    error,
    login,
    logout
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};